import React from 'react';
import Icon from '../common/Icons';
import AdminRowActionMenu from './ui/AdminRowActionMenu';
import AffiliationBadge from '../companies/AffiliationBadge';
import {
  formatCompanyContactLine,
  formatCompanyLocationLine
} from '../companies/companyListUtils';

function getCompanyInitials(company) {
  const code = (company?.company_code || '').trim();
  if (code.length >= 2) return code.slice(0, 2).toUpperCase();
  const name = (company?.name || '').trim();
  if (!name) return 'S';
  return name.slice(0, 2).toUpperCase();
}

export default function CompanyRowActionMenu({
  anchorEl,
  company,
  cities = [],
  resolveForCompany,
  onClose,
  onEdit,
  onToggleStatus,
  onDelete,
  disabled = false
}) {
  if (!company || !anchorEl) return null;

  const contact = formatCompanyContactLine(company);
  const location = formatCompanyLocationLine(company, cities);
  const affiliation = resolveForCompany ? resolveForCompany(company) : null;

  return (
    <AdminRowActionMenu
      anchorEl={anchorEl}
      onClose={onClose}
      title={company.name}
      subtitle={contact || company.company_code || 'Société adhérente'}
      initials={getCompanyInitials(company)}
      badges={[
        {
          label: company.is_active ? 'Active' : 'Inactive',
          variant: company.is_active ? 'active' : 'inactive'
        },
        company.company_code
          ? { label: company.company_code, variant: 'neutral' }
          : null
      ].filter(Boolean)}
      disabled={disabled}
      items={[
        {
          id: 'edit',
          label: 'Modifier',
          hint: 'Fiche société',
          icon: 'edit',
          tone: 'primary',
          onClick: () => {
            onClose();
            onEdit(company);
          }
        },
        {
          id: 'toggle',
          label: company.is_active ? 'Désactiver' : 'Réactiver',
          hint: company.is_active ? 'Retirer du répertoire actif' : 'Remettre en service',
          icon: company.is_active ? 'eyeSlash' : 'checkCircle',
          tone: 'warn',
          onClick: () => {
            onToggleStatus(company);
            onClose();
          }
        }
      ]}
      extra={
        <>
          {affiliation ? <AffiliationBadge affiliation={affiliation} variant="compact" /> : null}
          <span className={`co-location-line ${location.empty ? 'co-location-line--muted' : ''}`}>
            {location.text}
          </span>
        </>
      }
      footer={
        <button
          type="button"
          role="menuitem"
          className="adm-row-menu__item adm-row-menu__item--danger"
          disabled={disabled}
          onClick={() => {
            onDelete(company.id);
            onClose();
          }}
        >
          <span className="adm-row-menu__icon adm-row-menu__icon--danger" aria-hidden>
            <Icon name="trash" size={15} />
          </span>
          <span className="adm-row-menu__item-text">
            <span className="adm-row-menu__item-label">Supprimer la société</span>
            <span className="adm-row-menu__item-hint">Action irréversible</span>
          </span>
        </button>
      }
    />
  );
}
